import React from 'react';
import DataResource from './../../../common/DataResource'
import Panel from './../../../common/layout/Panel'


export default class extends React.Component {
    render () {
        const carrierId = this.props.match.params.carrier_id;
        const today = new Date();
        const data = {
            url: `/admin/carriers/carriers/${carrierId}/smslog`,
            limit: 50,
            offset: 0,
            userfilter:
            [
                {
                    source: 'ATRTIMESTAMP',
                    label: 'Date',
                    type: 'date_range',
                    default: {
                        'from' : new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0),
                        'to': new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59)
                    }
                },
                {
                    source: 'ATRDESTADDR',
                    label: 'Dest. Address',
                    type: 'text',
                    default: ''
                },
                {
                    source: 'ATRSRCADDR',
                    label: 'Source Address',
                    type: 'text',
                    default: ''
                }
            ],
            filter: {},
            datalen: 0,
            datarows: [],
            servermeta: [],
            loading: false,
            metadata:
                [
                    {
                        label: 'id',
                        source: 'ATRMESSAGEID',
                        type: 'primary',
                        visible: false
                    },
                    {
                        label: 'Timestamp',
                        source: 'ATRTIMESTAMP',
                        type: 'datetime',
                    },
                    {
                        label: 'Direction',
                        source: 'ATRDIRECTION',
                        type: 'icon',
                        values : {
                            in: 'INBOUND',
                            out: 'OUTBOUND'
                        },
                        classnames : {
                            in: 'label label-info',
                            out: 'label label-warning'
                        }
                    },
                    {
                        label: 'Dest. Address',
                        source: 'ATRDESTADDR',
                        type: 'text',
                    },
                    {
                        label: 'Src. Address',
                        source: 'ATRSRCADDR',
                        type: 'text'
                    },
                    {
                        label: 'Dest. Network',
                        source: 'ATRCLIENTDESTNAME',
                        type: 'text'
                    },
                    {
                        label: 'Billed Amount',
                        source: 'ATRCLIENTAMOUNT',
                        type: 'text'
                    },
                    {
                        label: 'Cost',
                        source: 'ATRCARRIERAMOUNT',
                        type: 'text'
                    },
                    {
                        label: 'Msg Parts',
                        source: 'ATRNUMPARTS',
                        type: 'text'
                    },
                    {
                        label: 'Msg Size',
                        source: 'ATRMSGSIZE',
                        type: 'text'
                    },
                    {
                        source: 'SMSSERVER',
                        type: 'text',
                        label: 'Server'
                    },
                ]
        }
        return (
            <Panel title = "SMS Log">
                <DataResource
                    data = {data}
                    {...this.props} 
                />
            </Panel>
        )
    }
}
